import { render, staticRenderFns } from "./WhiteViewer.vue?vue&type=template&id=d641b4aa&scoped=true&"
import script from "./WhiteViewer.vue?vue&type=script&lang=js&"
export * from "./WhiteViewer.vue?vue&type=script&lang=js&"
import style0 from "./WhiteViewer.vue?vue&type=style&index=0&id=d641b4aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d641b4aa",
  null
  
)

export default component.exports